import { render, staticRenderFns } from "./Delivered.vue?vue&type=template&id=77803380&scoped=true"
import script from "./Delivered.vue?vue&type=script&lang=js"
export * from "./Delivered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77803380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77803380')) {
      api.createRecord('77803380', component.options)
    } else {
      api.reload('77803380', component.options)
    }
    module.hot.accept("./Delivered.vue?vue&type=template&id=77803380&scoped=true", function () {
      api.rerender('77803380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/bulletinBoard/receivablesStatistics/Delivered.vue"
export default component.exports